import axios from '@/axios';
import type { WaitingListAvailabilityPerDay } from '@/types';

interface Options {
  locationId: string;
  serviceIds?: number[];
}

interface Params {
  service_ids?: number[];
}

export const loadWaitingListAvailabilities: (
  options: Options
) => Promise<WaitingListAvailabilityPerDay[] | null> = ({
  locationId,
  serviceIds
}) => {
  const params: Params = {
    service_ids: serviceIds || []
  };

  return axios
    .get(`/locations/${locationId}/availabilities/waiting_list`, { params })
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      }
      return new Promise((_resolve, reject) =>
        reject(new Error(response.statusText))
      );
    })
    .catch((e) => {
      throw new Error('Server error.', e);
    });
};
